import {FormModal} from "@/components/form/overlay/FormModal.tsx";
import {ChartNameForm, ChartNameFormValues} from "@/pages/metricsExplorer/savedViews/ChartNameForm.tsx";

export type ChartNameMode = "save" | "saveAs" | "rename";

const TITLES: Record<ChartNameMode, string> = {
  save: "Save Chart",
  saveAs: "Save as New Chart",
  rename: "Rename Chart",
};

interface ChartNameModalProps {
  mode: ChartNameMode | null;
  defaultName: string;
  onSubmit: (values: ChartNameFormValues) => void;
  onCancel: () => void;
}

const FORM_ID = "metricsExplorerChartName";

export const ChartNameModal = ({mode, defaultName, onSubmit, onCancel}: ChartNameModalProps) => (
  <FormModal
    show={mode !== null}
    title={mode ? TITLES[mode] : ""}
    formId={FORM_ID}
    submitBtnText={mode === "rename" ? "Rename" : "Save"}
    onCancel={onCancel}
  >
    {mode && <ChartNameForm id={FORM_ID} defaultName={defaultName} onSubmit={onSubmit} />}
  </FormModal>
);
